// extracted by mini-css-extract-plugin
export var articleIntro = "page-intro2-module--articleIntro--e67b8";
export var button = "page-intro2-module--button--b7a11";
export var centered = "page-intro2-module--centered--37582";
export var centeredSubtitle = "page-intro2-module--centeredSubtitle--68fde typography-module--responsiveTitle4Sans--7ff5d";
export var centeredTitle = "page-intro2-module--centeredTitle--0d1cc typography-module--responsiveTitle1Medium--1f97c";
export var content = "page-intro2-module--content--588a5";
export var cta = "page-intro2-module--cta--d958e";
export var date = "page-intro2-module--date--8e120";
export var excerpt = "page-intro2-module--excerpt--c85a4";
export var grid = "page-intro2-module--grid--59df9";
export var grid2Col = "page-intro2-module--grid2Col--d9938";
export var h2 = "page-intro2-module--h2--898e3";
export var image = "page-intro2-module--image--cb004";
export var imagePlaceholder = "page-intro2-module--imagePlaceholder--76e7d";
export var indexIntro = "page-intro2-module--indexIntro--43ff7";
export var left = "page-intro2-module--left--d3f44";
export var mainTitle = "page-intro2-module--mainTitle--f261e";
export var pageMedTitle = "page-intro2-module--pageMedTitle--53b53 typography-module--responsiveTitle1MediumLight--017d5";
export var pageTitle = "page-intro2-module--pageTitle--577f9 typography-module--responsiveTitle1Medium--1f97c";
export var productIntro = "page-intro2-module--productIntro--b0af0";
export var root = "page-intro2-module--root--903d3";
export var sectionImage = "page-intro2-module--sectionImage--932a5";
export var sectionTitle = "page-intro2-module--sectionTitle--65300 typography-module--responsiveTitle1Medium--1f97c";
export var subtitle = "page-intro2-module--subtitle--e7baa typography-module--responsiveTitle4Sans--7ff5d";
export var textContent = "page-intro2-module--textContent--d9565";
export var textTitle = "page-intro2-module--textTitle--1762e";
export var title = "page-intro2-module--title--dcf39 typography-module--responsiveTitle1Medium--1f97c";
export var titleSans = "page-intro2-module--titleSans--2ff60 typography-module--responsiveTitle1Sans--e467b";
export var wrapper = "page-intro2-module--wrapper--b812d";